
import {navigateToFirst, navigateToPrevious, navigateToNext,navigateToLast} from '../utils/operations'
import React, {Component} from 'react';
import { connect } from 'react-redux'
import ISpan from "../i18n/ISpan";


class PaginationUnit extends Component{
    isFirstPage(){
        return this.props.paging? Number(this.props.paging.currentPage) === 1: false;
    }

    isLastPage(){
        return this.props.paging? Number(this.props.paging.currentPage) === Number(this.props.paging.totalPages): false;
    }

    render() {
        let props = this.props;

        return <div className={"pagination-container container ten columns"} data-bind="with:paging">
            {props.paging && <ul>
                {
                    !this.isFirstPage() && <li className={"pagination-li"}>
                        <a href="#" data-bind="click: function(){gotoPage(1);}" onClick={this.props.navigateToFirst}>

                            <span className={"fa fa-angle-double-left"}></span><span><ISpan localisationId="common.navigation.first" defaultValue="First"/></span></a>
                    </li>
                }
                {!this.isFirstPage() && <li className={"pagination-li"}>
                    <a href="#" data-bind="click: function(){gotoPrevious();}" onClick={props.navigateToPrevious}><span
                        className={"fa fa-angle-left"}></span><ISpan localisationId="common.navigation.previous" defaultValue="Previous"/></a>
                </li>}

                <li className={"pagination-li"}>
                                    <span><span> <ISpan localisationId="common.navigation.page" defaultValue="Page"/></span> <span
                                        data-bind="text:currentPage()">{props.paging.currentPage}</span> <span>
                                        <ISpan localisationId="common.navigation.of" defaultValue="of"/></span> <span
                                        data-bind="text:totalPages()">{props.paging.totalPages}</span></span>
                </li>
                {!this.isLastPage() && <li className={"pagination-li"}>
                    <a href="#" data-bind="click: function(){gotoNext();}" onClick={props.navigateToNext}><span>
                        <ISpan localisationId="common.navigation.next" defaultValue="Next"/></span> <span
                        className={"fa fa-angle-right"}></span></a>
                </li>}

                {!this.isLastPage() && <li className={"pagination-li"}>
                    <a href="#" data-bind="click: function(){gotoPage(totalPages());}"
                       onClick={props.navigateToLast}><span>
                        <ISpan localisationId="common.navigation.last" defaultValue="Last"/></span> <span
                        className={"fa fa-angle-double-right"}></span></a>
                </li>}
            </ul>}

            {/*currentPage, resultsPerPage, totalPages, totalResults*/}
        </div>
    };
}



export default PaginationUnit = connect((state) => {
    return {
        paging: state.searchResults.results.paging
    }
}, (dispatch) => {
    return {
        navigateToFirst: () => dispatch(navigateToFirst()),
        navigateToPrevious: () => dispatch(navigateToPrevious()),
        navigateToNext: () => dispatch(navigateToNext()),
        navigateToLast: () => dispatch(navigateToLast())
    }
})(PaginationUnit);



// WEBPACK FOOTER //
// ./src/components/PaginationUnit.js